/**
 * @deprecated Use `@/features/profile/api/homeowner-profile.api` instead.
 * Backward-compatible wrappers that extract userId from in-memory JWT.
 */

import { getAccessToken } from "@/shared/lib/auth-fetch"
import * as HoProfileApi from "../api/homeowner-profile.api"
import type { HomeownerProfileFormType } from "../schemas/homeowner-profile-form.schema"

export { HOMEOWNER_PROFILE_QUERY_KEYS } from "../api/homeowner-profile.api"

function getUserIdFromToken(): number {
  const token = getAccessToken()
  if (!token) throw new Error("No session found")
  try {
    const payload = JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")))
    return parseInt(payload.sub)
  } catch {
    throw new Error("No session found")
  }
}

export async function getHomeownerProfile() {
  return HoProfileApi.getHomeownerProfile(getUserIdFromToken())
}

export async function updateHomeownerProfile(
  data: Partial<HomeownerProfileFormType>,
  homeownerId?: number,
) {
  return HoProfileApi.updateHomeownerProfile(data, homeownerId, getUserIdFromToken())
}
